import React from 'react';
import StatusPage from '../components/StatusPage';

export default function Pending() {
  return (
    <StatusPage
      variant="pending"
      icon="⏳"
      title="Pago en proceso"
      message="Tu pago está pendiente de confirmación. Te avisaremos por email cuando se confirme."
    />
  );
}
